export default ({
    medicalRecordsAttendances: [],
    medicalRecordsStatus: {},
    fetchMedicalRecordsAttendancesReports: false,
    filter: {
        workspaces: [],
        professionals: [],
        clients: [],
    },
});